document.addEventListener("DOMContentLoaded", (event) => {

  /* color swatches collection page -- Start */
  window.handleCustomCollectionSwatchChange = function(){
    document.querySelectorAll(".custom-collection-swatch input").forEach(el => {
      el.addEventListener("change", function(e){
          e.preventDefault();
            var selectedInput = e.target; 
            var selectedValue = e.currentTarget.value; // Get the value from the input
            var closestCardInformation  = e.currentTarget.closest(".card-information");
            var swatchElements = closestCardInformation.querySelectorAll('.swatch-element');
            var inputElement = closestCardInformation.querySelectorAll('.swatch-element input[type="radio"]');
            swatchElements.forEach(function(swatchElement) {
            var inputElements = swatchElement.querySelectorAll('input[type="radio"]');
            inputElements.forEach(function(inputElement) {
              inputElement.classList.remove('checked');
            });
            });
            selectedInput.classList.add('checked');
          var variantImageElement = closestCardInformation.querySelector(`[all_variants] span[variant-name^="${selectedValue} "]`);
        
          if (variantImageElement) {
            var variantImage = variantImageElement
            var variantImg = closestCardInformation.querySelector(`[all_variants] span[variant-name^="${selectedValue} "] img`);
            if(variantImg){
              var cardMedia = e.currentTarget.closest(".card-wrapper").querySelector(".card__media .media");
              
              cardMedia.innerHTML = ''; // Clear existing content
              // Clone the image element and then append the clone to the new location
              var clonedVariantImg = variantImg.cloneNode(true);
              cardMedia.appendChild(clonedVariantImg);
            }
            var variantUrl = closestCardInformation.querySelector(`[all_variants] span[variant-name^="${selectedValue} "]`).getAttribute("variant-url");
            e.currentTarget.closest(".card-wrapper").querySelectorAll("a.product-url__collection").forEach(ele => {
              ele.href = variantUrl;
            });
          } else {
            console.log("Variant not found.");
          }
      }, true);
    });
  }
  window.handleCustomCollectionSwatchChange();
  /* color swatches collection page -- End */

  // Function to prevent body scroll
  const preventBodyScroll = (event) => {
    const openModals = document.querySelectorAll('modal-dialog[open]');
    
    if (openModals.length > 0) {
      const touch = event.touches[0];
      let isOutsideAllModals = true;
  
      openModals.forEach(modal => {
        const modalBounds = modal.getBoundingClientRect();
        
        // Check if the touch/swipe is within any open modal
        const isInsideModal = (
          touch.clientX >= modalBounds.left &&
          touch.clientX <= modalBounds.right &&
          touch.clientY >= modalBounds.top &&
          touch.clientY <= modalBounds.bottom
        );
  
        if (isInsideModal) {
          isOutsideAllModals = false;
        }
      });
  
      if (isOutsideAllModals) {
        event.preventDefault(); // Prevent default scroll behavior
      }
    }
  };
  
  // Disable scroll on touchmove and touchstart if outside modal
  const disableScrollIfOutsideModal = (event) => {
    const openModals = document.querySelectorAll('modal-dialog[open]');
    
    if (openModals.length > 0) {
      const touch = event.touches[0];
      let isOutsideAllModals = true;
  
      openModals.forEach(modal => {
        const modalBounds = modal.getBoundingClientRect();
        
        const isInsideModal = (
          touch.clientX >= modalBounds.left &&
          touch.clientX <= modalBounds.right &&
          touch.clientY >= modalBounds.top &&
          touch.clientY <= modalBounds.bottom
        );
  
        if (isInsideModal) {
          isOutsideAllModals = false;
        }
      });
  
      if (isOutsideAllModals) {
        event.preventDefault(); // Prevent scrolling
      }
    }
  };
  
  // Lock body scroll when a modal is open on touchstart
  document.addEventListener('touchstart', function(event) {
    const openModals = document.querySelectorAll('modal-dialog[open]');
    
    if (openModals.length > 0) {
      document.body.style.overflow = 'hidden'; // Disable body scroll
    }
  
    disableScrollIfOutsideModal(event);
  }, { passive: false });
  
  // Prevent default scroll behavior on touchmove
  document.addEventListener('touchmove', preventBodyScroll, { passive: false });
  
  // Re-enable body scroll when touch ends and no modal is open
  document.addEventListener('touchend', function() {
    const openModals = document.querySelectorAll('modal-dialog[open]');
    
    if (openModals.length === 0) {
      document.body.style.overflow = ''; // Re-enable body scroll
    }
  });
  
  // Add 'touch-action: none' to prevent touch gestures from triggering scroll
  document.querySelectorAll('modal-dialog').forEach(modal => {
    modal.style.touchAction = 'none';  // Disable touch gestures triggering scroll
  });



  
});

document.querySelectorAll('textarea').forEach((textarea) => {
    textarea.addEventListener('touchstart', function (e) {
        e.stopPropagation();
    });
});
